import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../environments/environment';
import { IAppConfig } from './models/app-config.model';
import { firstValueFrom } from 'rxjs';
 
@Injectable({
  providedIn: 'root'
})
export class AppConfig {
  static settings: IAppConfig;
  constructor(private http: HttpClient) {}
  load(): Promise<void> {
    const jsonFile = `assets/config/config.${environment.name}.json`;
    return firstValueFrom(this.http.get<IAppConfig>(jsonFile))
      .then((response) => {
        AppConfig.settings = response;
      })
      .catch((error) => {
        return Promise.reject(
          new Error(`Could not load file '${jsonFile}': ${JSON.stringify(error)}`)
        );
      });
  }
}